import columns from '../../../react-table/helpers/columns';

export default (data) => {
  const {
    FilteredDateColumn,
    FilteredNumberColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new FilteredDateColumn('Date', 'date'),
        new FilteredNumberColumn('BoH', 'boh'),
        new FilteredNumberColumn('Transit', 'transit'),
        new FilteredNumberColumn('Out', 'out'),
        new FilteredNumberColumn('In', 'in'),
        new FilteredNumberColumn('Flux', 'flux'),
        new FilteredNumberColumn('Limbo', 'limbo'),
        new FilteredNumberColumn('On Hold', 'onHold'),
        new FilteredNumberColumn('Bal Mod', 'balanceModification'),
        new FilteredNumberColumn('Total BoH', 'total'),
      ],
    },
  ];
};
